import { render, staticRenderFns } from "./FooterNewCopy.vue?vue&type=template&id=86d8fe26&scoped=true&"
import script from "./FooterNewCopy.vue?vue&type=script&lang=js&"
export * from "./FooterNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./FooterNewCopy.vue?vue&type=style&index=0&id=86d8fe26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d8fe26",
  null
  
)

export default component.exports